import { action } from 'mobx';
import { getLoginRoute } from 'core/utils';
import { localStorageHandler } from 'core/services';
import { LoginService } from 'common/data';
import _ from 'lodash';

class LoginStore {
	constructor(rootStore) {
		this.rootStore = rootStore;
		this.loginService = new LoginService(rootStore.app.baasic.apiClient, rootStore.app.baasic.tokenHandler);
	}

	@action
	login = async ({ username, password, organization, options }) => {
		const response = await this.loginService.login({ username, password, organization, options });
		return response;
	};

	@action.bound
	logout = async () => {
		const { token, type } = this.rootStore.app.baasic.getAccessToken();
		await this.rootStore.app.baasic.membershipModule.login.logout(token, type);
		this.rootStore.app.baasic.updateAccessToken(null);
		const timerList = localStorageHandler.get('two-step-authentication-timer');
		localStorageHandler.clear();
		if (timerList != null) {
			localStorageHandler.set('two-step-authentication-timer', timerList);
		}
		await this.rootStore.routerStore.goTo(getLoginRoute(this.rootStore.routerStore.routerState.params.appId));
	};
}

export default LoginStore;
